//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const SHOW_DELETE_BTN_WIDTH = 80
export default {
    props: {
        item: Object
    },
    data () {
         return {
            move_starting: false,
            start_x: 0,
            start_y: 0,
            show_del: false
        }
    },
    methods: {
        touchstart (e) {
            this.move_starting = true
            const { pageX, pageY } = e.touches[0]
            this.start_x = pageX
            this.start_y = pageY
            console.error(pageX, pageY)
        },
        touchmove (e) {
            const { pageX, pageY } = e.touches[0]
            const left = pageX - this.start_x
            const top = pageY - this.start_y
            if (
                Math.abs(left) > Math.abs(top) // check move angle
                &&
                Math.abs(left) >= SHOW_DELETE_BTN_WIDTH
            ) {
                this.show_del = left < 0
                this.$emit('disableScroll')
            }
        },
        touchend (e) {
            this.move_starting = false
            this.$emit('enableScroll')
        }
    }
}
